"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPermissionForTask = void 0;
const types_1 = require("../typings/types");
const Member_1 = require("./Member");
const Util_1 = require("./Util");
const hasPermissionForTask = (member) => (task) => Member_1.hasPermission('AssignTasks')(types_1.Permissions.AssignTasks.YES)(member) ||
    Member_1.areMembersTheSame(member)(task.tasker) ||
    task.results.map(Util_1.get('tasked')).some(Member_1.areMembersTheSame(member));
exports.hasPermissionForTask = hasPermissionForTask;
//# sourceMappingURL=Tasks.js.map